module.exports = __webpack_public_path__ + "img/nb.6ad53928.svg";